"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _color = require("../../../scripts/utils/color");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(_ref) {
  var colorScheme = _ref.colorScheme;
  var color0 = colorScheme.color0,
      color1 = colorScheme.color1,
      color2 = colorScheme.color2,
      color3 = colorScheme.color3,
      color4 = colorScheme.color4,
      color5 = colorScheme.color5;
  var DEFAULT_SECTION_ATOMS = {
    _section: {
      sectionMain: {
        backgroundColor: color4
      }
    }
  };
  var DEFAULT_ELEMENT_HEADER = {
    header: {
      main: {
        color: color3
      }
    }
  };
  return {
    header: {
      _section: {
        sectionMain: {
          backgroundColor: null
        }
      },
      eventName: {
        main: {
          color: color5
        }
      },
      registerButton: {
        main: {
          backgroundColor: color0,
          color: color5,
          borderColor: (0, _color.setAlpha)('#000000', 0)
        }
      },
      eventDate: {
        main: {
          color: color5
        }
      },
      eventVenue: {
        main: {
          color: color5
        }
      },
      eventSecondaryHeaders: {
        header1: {
          color: color5
        },
        header2: {
          color: color5
        }
      }
    },
    description: _objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), {}, {
      header: {
        main: {
          color: color1
        }
      },
      description: {
        main: {
          color: color3
        }
      }
    }),
    tickets: {
      _section: {
        sectionMain: {
          backgroundColor: color5
        }
      },
      header: {
        main: {
          color: color1
        }
      }
    },
    speakers: _objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), {}, {
      header: {
        main: {
          color: color1
        }
      },
      speakers: {
        fullname: {
          color: color2
        },
        text1: {
          color: color2
        },
        text2: {
          color: color2
        }
      }
    }),
    attendees: _objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), {}, {
      header: {
        main: {
          color: color1
        }
      },
      attendees: {
        name: {
          color: color2
        },
        text1: {
          color: color2
        }
      },
      button: {
        main: {
          color: color5,
          backgroundColor: color1
        }
      }
    }),
    people: _objectSpread({
      _section: {
        sectionMain: {
          backgroundColor: color4
        }
      },
      people: {
        text1: {
          color: color2
        },
        text2: {
          color: color3
        },
        text3: {
          color: color3
        }
      }
    }, DEFAULT_ELEMENT_HEADER),
    sponsors: _objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), {}, {
      header: {
        main: {
          color: color1
        }
      },
      sponsors: {
        main: {
          color: '#595a5c'
        }
      }
    }),
    exhibitors: _objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), {}, {
      header: {
        main: {
          color: color1
        }
      },
      exhibitors: {
        main: {
          color: '#595a5c'
        }
      }
    }),
    multiElement: _objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), DEFAULT_ELEMENT_HEADER),
    form: {
      _section: {
        sectionMain: {
          backgroundColor: color5
        }
      },
      form: {
        title: {
          color: color1
        },
        label: {
          color: color3
        },
        separator: {
          color: color3
        },
        button: {
          backgroundColor: color1,
          color: '#FFFFFF'
        },
        secondaryLabel: {
          color: color3
        }
      }
    },
    buttons: {
      _section: {
        sectionMain: {
          backgroundColor: color4
        }
      },
      eventButtons: {
        main: {
          backgroundColor: '#ffffff',
          color: '#2BB0E9',
          borderColor: '#2BB0E9'
        }
      }
    },
    downloadApp: {
      _section: {
        sectionMain: {
          backgroundColor: color2
        },
        text: {
          color: color4
        },
        highlight: {
          color: color1
        }
      }
    },
    iframe: _objectSpread({}, DEFAULT_SECTION_ATOMS),
    countdownClock: {
      _section: {
        sectionMain: {
          backgroundColor: color5
        }
      },
      header: {
        main: {
          color: color1
        }
      },
      countdownClock: {
        main: {
          color: color2,
          backgroundColor: color4,
          borderColor: color1
        },
        text: {
          color: color3
        }
      }
    },
    eventVenue: {
      _section: {
        sectionMain: {
          backgroundColor: '#ffffff'
        }
      },
      header: {
        main: {
          color: color1
        }
      },
      eventVenue: {
        main: {
          color: color1
        },
        text: {
          color: color3
        }
      }
    }
  };
};

exports.default = _default;